module.exports = __webpack_public_path__ + "static/media/ntakos_thumb2.f31fa79c.jpg";